import React from 'react';
import { getLayoutItem } from '../helpers/layoutHelper';

export function LayoutImage({ node }) {
    const layout_items = Object.values(node.relationships).map(getLayoutItem);
    return <>{layout_items}</>
}